import React, { useContext, useState } from 'react';
import { Plus, Eye, Edit2, Ban, CheckCircle, ChevronLeft, ChevronRight } from 'lucide-react';
import { Row, Col, Card, Form, InputGroup, Modal, Button } from 'react-bootstrap';
import '../../../../assets/css/admin/dashboardCSS/SubAdmins.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import TitleBar from '../../../../subscreens/admin/TitleBar';
import { FaSearch, FaFilter } from 'react-icons/fa';
import AppContext from "../../../../context/AppContext";
import { useEffect } from "react";
import axios from 'axios';

const SubAdminManagement = () => {
  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [Id, setID] = useState();
  const [Image, setImage] = useState();
  const [Name, setName] = useState();
  const [Email, setEmail] = useState();
  const [Role, setRole] = useState();
  const [Password, setPassword] = useState();
  const [Status, setStatus] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All Status');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [isLoading, setisLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  // const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [NameError, setNameError]=useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");


  const [subAdmins, setSubAdmins] = useState([]);

  const createSubAdmin = () => {
    setisLoading(true);
    const formData = new FormData();
    formData.append("name", Name);
    formData.append("email", Email);
    formData.append("password", Password);
    formData.append('role', Role)
    formData.append("status", Status);

    axios
      .post(`${baseUrl}/admin/subAdmin/createSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
        setShowAddModal(false);
        setName('');
        setEmail('');
        setPassword('');
        setRole('Sub Admin');
        setStatus('ENABLED');
      })

      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setisLoading(false);
      });
  };

  const updateSubAdmin = () => {
    setisLoading(true);
    const formData = new FormData();
    formData.append("id", selectedAdmin?.id);
    formData.append("file", Image);
    formData.append("name", Name);
    formData.append("email", Email);
    formData.append("password", Password);
    formData.append("status", Status);
    formData.append('isSuperAdmin', Role === "Admin" ? 0 : 1);

    axios
      .post(`${baseUrl}/admin/subAdmin/updateSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
        // setShowEditModal(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setisLoading(false);
      });
  };

  const viewAllSubAdmin = () => {
    axios
      .get(`${baseUrl}/admin/subAdmin/viewAllSubAdmin`)
      .then((response) => {
        console.log(response.data);
        setSubAdmins(response.data);
        console.log('success called');
      })
      .catch((error) => {
        console.log(error);
        console.log('error called');
      });
  };

  useEffect(() => {
    viewAllSubAdmin();
  }, []);

  //   Filter sub admins
  const filteredAdmins = (subAdmins || []).filter((admin) => {
    const searchText = searchTerm.toLowerCase();

    const name = admin?.name ?? "";
    const email = admin?.email ?? "";

    const matchesSearch =
      name.toLowerCase().includes(searchText) ||
      email.toLowerCase().includes(searchText);

    const matchesStatus =
      statusFilter === "All Status" || admin?.status === statusFilter;

    return matchesSearch && matchesStatus;
  });
  //Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAdmins = filteredAdmins.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredAdmins.length / itemsPerPage);

  const handleAddNew = () => {
    setName('');
    setEmail('');
    setPassword('');
    setRole('Content Admin');
    setStatus('ENABLED');

    setShowAddModal(true);
  };
  const handleView = (admin) => {
    setSelectedAdmin(admin);
    setShowViewModal(true);
  };

  const handleEdit = (admin) => {
    setSelectedAdmin(admin);

    setName(admin.name);
    setEmail(admin.email);
    setPassword('');
    setRole(admin.role);
    setStatus(admin.status);

    // setShowEditModal(true);
  };

  const ToggleStatus = (admin) => {
    setSubAdmins(subAdmins.map(a =>
      a.id === admin.id
        ? { ...a, status: a.status === 'ENABLED' ? 'DISABLED' : 'ENABLED' }
        : a
    ));

      axios.post(`${baseUrl}/admin/subAdmin/toggleStatus`, { id: admin.id })
    .then(res => {
      const updatedStatus = res.data.status;
      setSubAdmins(subAdmins.map(a =>
        a.id === admin.id
          ? { ...a, status: updatedStatus }
          : a
      ));
    })
    .catch(err => {
      console.log(err);
      setSubAdmins(subAdmins.map(a =>
        a.id === admin.id
          ? { ...a, status: admin.status } 
          : a
      ));
      alert("Failed to update status");
    });
  };


  const getStatusClass = (status) => {
    return status === 'ENABLED' ? 'sa-status-ENABLED' : 'sa-status-DISABLED';
  };

  return (
    <Adminlayout>
      <div className="sa-container">
        {/* Header */}
        <div className="sa-header">
          <TitleBar
            title="Sub Admin Management"
            subtitle="Manage all sub-admin accounts"
          ></TitleBar>
        </div>

        <div className="d-flex justify-content-end mb-3">
          <button className="sa-add-btn" onClick={handleAddNew}>
            <Plus size={20} />
            <span>Add Sub Admin</span>
          </button>
        </div>

        {/* Main Content */}
        <div className="sa-content">
          {/* Search and Filters */}
          <Card className="sa-filter-card mb-4">
            <Card.Body>
              <Row className="align-items-center">
                <Col lg={8} md={12} className="mb-3 mb-lg-0">
                  <InputGroup>
                    <InputGroup.Text className="sa-search-icon">
                      <FaSearch />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search by name, email, or ID..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="sa-search-input"
                    />
                  </InputGroup>
                </Col>

                <Col lg={4} md={12}>
                  <InputGroup>
                    <InputGroup.Text className="sa-filter-icon">
                      <FaFilter />
                    </InputGroup.Text>
                    <Form.Select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      className="sa-filter-select"
                    >
                      <option value="All Status">All Status</option>
                      <option value="ENABLED">Enabled</option>
                      <option value="DISABLED">Disabled</option>
                    </Form.Select>
                  </InputGroup>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Table */}
          <Card className="sa-table-card">
            <Card.Body>
              <h5 className="sa-table-title mb-4">Sub Admin List</h5>
              <div className="sa-table-container">
                <table className="sa-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentAdmins.map((admin, index) => (
                      <tr key={admin.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>
                          <img
                            src={admin.image ? `${baseUrl}/${admin.image}` : '/default-avatar.png'}
                            alt={admin.name}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              objectFit: 'cover',
                              border: '2px solid #1e2a4a'
                            }}
                          />
                        </td>
                        <td className="sa-table-name">{admin.name}</td>
                        <td>{admin.email}</td>
                        <td>{admin.isSuperAdmin == 0 ? "Admin" : "Sub Admin"}</td>
                        {/* <td>{admin.role}</td> */}
                        <td>
                          <span className={`sa-status-badge ${getStatusClass(admin.status)}`}>
                            {admin.status}
                          </span>
                        </td>
                        <td>
                          <div className="sa-actions">
                            <button
                              className="sa-action-btn sa-view"
                              onClick={() => handleView(admin)}
                              title="View"
                            >
                              <Eye size={16} />
                            </button>
                            {/* <button
                              className="sa-action-btn sa-edit"
                              onClick={() => handleEdit(admin)}
                              title="Edit"
                            >
                              <Edit2 size={16} />
                            </button> */}
                            <button
                              className={`sa-action-btn ${admin.status === 'ENABLED' ? 'sa-disable' : 'sa-enable'}`}
                              onClick={() => ToggleStatus(admin)}
                              title={admin.status === 'ENABLED' ? 'DISABLED' : 'ENABLED'}
                            >
                              {admin.status === 'ENABLED' ? <Ban size={16} /> : <CheckCircle size={16} />}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="sa-pagination">
                  <div className="sa-pagination-info">
                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredAdmins.length)} of {filteredAdmins.length} entries
                  </div>
                  <div className="sa-pagination-controls">
                    <button
                      className="sa-page-btn"
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <ChevronLeft size={18} />
                      Prev
                    </button>

                    {[...Array(totalPages)].map((_, index) => (
                      <button
                        key={index + 1}
                        className={`sa-page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                        onClick={() => setCurrentPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    ))}

                    <button
                      className="sa-page-btn"
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                      <ChevronRight size={18} />
                    </button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>

        {/* Add Modal */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Add Sub Admin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  value={Name}
                  onChange={(event) => {
                    setName(event.target.value);
                    setNameError(regExpChecker("name",event.target .value))
                  }
                  }
                   
                />
                   <p style={{ color: "red" }}>{NameError}</p>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={Email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                     setEmailError(regExpChecker("email", event.target.value));
                  }
                  }

                />
                      <p style={{ color: "red" }}>{emailError}</p>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={Password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setPasswordError(regExpChecker("password", event.target.value));
                  }
                  }

                />
                 <p style={{ color: "red" }}>{passwordError}</p>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                <div className="sa-radio-group">
                  <Form.Check
                    type="checkbox"
                    label="Sub Admin"
                    checked={Role === 'Sub Admin'}
                    onChange={() => setRole('Sub Admin')}
                    inline
                  />
                  <Form.Check
                    type="checkbox"
                    label="Moderator"
                    checked={Role === 'Moderator'}
                    onChange={() => setRole('Moderator')}
                    inline
                  />
                </div>
              </Form.Group>

              {/* <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  value={Role}
                  onChange={(event)=>{
                  setRole(event.target.value);}
                  }
                >
                  <option value="Content Admin">Content Admin</option>
                  <option value="Support Admin">Support Admin</option>
                  <option value="Finance Admin">Finance Admin</option>
                </Form.Select>
              </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <div className="sa-radio-group">
                  <Form.Check
                    type="radio"
                    label="Enabled"
                    name="status"
                    checked={Status === 'ENABLED'}
                    onChange={() => setStatus('ENABLED')}
                    inline
                  />

                  <Form.Check
                    type="radio"
                    label="Disabled"
                    name="status"
                    checked={Status === 'DISABLED'}
                    onChange={() => setStatus('DISABLED')}
                    inline
                  />
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={createSubAdmin}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
         {/* <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Sub Admin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>

              <Form.Group className="mb-3">
                <Form.Label>Profile Image</Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control

                  type="text"
                  placeholder="Enter name"
                  value={Name}
                  onChange={(event) => {
                    setName(event.target.value);
                  }}

                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={Email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password (Leave empty to keep current)</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter new password"
                  value={Password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                <div className="sa-radio-group">
                  <Form.Check
                    type="checkbox"
                    label="Sub Admin"
                    checked={Role === 'Sub Admin'}
                    onChange={() => setRole("Sub Admin")}
                    inline
                  />
                  <Form.Check
                    type="checkbox"
                    label="Moderator"
                    checked={Role === 'Moderator'}
                    onChange={() => setRole("Moderator")}
                    inline
                  />
                </div>
              </Form.Group>

               <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  value={Role}
                  onChange={(event)=>{
                    setRole(event.target.value);
                  }}
                >
                  <option value="Content Admin">Content Admin</option>
                  <option value="Support Admin">Support Admin</option>
                  <option value="Finance Admin">Finance Admin</option>
                </Form.Select>
              </Form.Group> 

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <div className="sa-radio-group">
                  <Form.Check
                    type="radio"
                    label="Enabled"
                    name="status"
                    checked={Status === 'ENABLED'}
                    onChange={() => setStatus('ENABLED')}
                    inline
                  />

                  <Form.Check
                    type="radio"
                    label="Disabled"
                    name="status"
                    checked={Status === 'DISABLED'}
                    onChange={() => setStatus('DISABLED')}
                    inline
                  />
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={updateSubAdmin}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </Button>
          </Modal.Footer>
        </Modal>  */}

        {/* View Modal */}
        <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Sub Admin Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedAdmin && (
              <div className="sa-view-details">
                <div className="sa-detail-row">
                  <strong>Profile Image:</strong>
                  <img
                    src={selectedAdmin.image ? `${baseUrl}/${selectedAdmin.image}` : '/default-avatar.png'}
                    alt={selectedAdmin.name}
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #1e2a4a'
                    }}
                  />
                </div>
                <div className="sa-detail-row">
                  <strong>Name:</strong>
                  <span>{selectedAdmin.name}</span>
                </div>
                <div className="sa-detail-row">
                  <strong>Email:</strong>
                  <span>{selectedAdmin.email}</span>
                </div>
                <div className="sa-detail-row">
                  <strong>Role:</strong>
                  <span>
                    {selectedAdmin.isSuperAdmin == 0 ? "Admin" : "Sub Admin"}
                  </span>
                </div>
                <div className="sa-detail-row">
                  <strong>Status:</strong>
                  <span className={`sa-status-badge ${getStatusClass(selectedAdmin.status)}`}>
                    {selectedAdmin.status}
                  </span>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowViewModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Adminlayout>
  );
};

export default SubAdminManagement;